import { render } from "./Work.vue?vue&type=template&id=1ff885c9"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__